import { withInstall } from '@tw-element/utils'

import Space from './src/space'

export const TwSpace = withInstall(Space)
export default TwSpace

export * from './src/space'
export * from './src/use-space'
